import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class AccountListItem extends Model {
  [Type] = 'account-list-item' as const;

  @attr('string') declare accountNumber: string;
  @attr('boolean') declare hasOverdueInvoices: boolean;
  @attr('string') declare name: string;
}
